import { render, staticRenderFns } from "./UbigeoSelector.vue?vue&type=template&id=4c06c4b4&scoped=true&"
import script from "./UbigeoSelector.vue?vue&type=script&lang=js&"
export * from "./UbigeoSelector.vue?vue&type=script&lang=js&"
import style0 from "./UbigeoSelector.vue?vue&type=style&index=0&id=4c06c4b4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c06c4b4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCardText,VCol,VIcon,VRow})
